/* @ngInject */
const movementCtrl = (
  $scope,
  $$movement
) => {
  $scope.$$movement = $$movement
}

export default movementCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/movement/movement.controller.js